'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _canvasUtil = require('../../canvas/dnd/canvasUtil');

var _fileValidator = require('../../utils/services/file/fileValidator');

var _keyboardUtility = require('../../utils/keyboard/keyboardUtility');

var _linkUtils = require('../../../common/links/linkUtils');

var _keyConstants = require('../../utils/keyboard/keyConstants');

require('./WorkspaceClipboardHandler.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Constants


// Styles


var DATA_TRANSFER_ITEM_KINDS = {
    FILE: 'file'
};

var DATA_TRANSFER_TYPES = {
    PLAIN_TEXT: 'text/plain',
    HTML: 'text/html',
    FILES: 'Files'
};

var WorkspaceClipboardHandler = function (_React$Component) {
    _inherits(WorkspaceClipboardHandler, _React$Component);

    function WorkspaceClipboardHandler() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WorkspaceClipboardHandler);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkspaceClipboardHandler.__proto__ || Object.getPrototypeOf(WorkspaceClipboardHandler)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (event) {
            if ((0, _keyboardUtility.hasCommandModifier)(event) && event.target === window.document.body && (event.keyCode === _keyConstants.KEY_CODES.CMD_LEFT || event.keyCode === _keyConstants.KEY_CODES.CMD_RIGHT || event.keyCode === _keyConstants.KEY_CODES.CTRL)) {
                _this.clipboardDiv.focus();
            }
        }, _this.onPaste = function (event) {
            if (document.activeElement !== window.document.body) return;
            var clipboardData = event.clipboardData;
            var _this$props = _this.props,
                currentBoardId = _this$props.currentBoardId,
                isEditable = _this$props.isEditable;


            if (!isEditable) return;

            var _getInboxLocation = (0, _canvasUtil.getInboxLocation)(currentBoardId),
                location = _getInboxLocation.location;

            var handlerData = { clipboardData: clipboardData, location: location };
            return _this.handleFile(handlerData) || _this.handleLink(handlerData) || _this.handleHtml({ clipboardData: clipboardData, location: location }) || _this.handlePlainText({ clipboardData: clipboardData, location: location });
        }, _this.handleFile = function (_ref2) {
            var clipboardData = _ref2.clipboardData,
                location = _ref2.location;

            // If there's no file data transfer type then can't get a file from the pasted data
            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.FILES)) return;

            var _this$props2 = _this.props,
                createShortcutImage = _this$props2.createShortcutImage,
                dispatchErrorUploadingElementAttachment = _this$props2.dispatchErrorUploadingElementAttachment;


            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
            var caption = (0, _linkUtils.isTextLink)(text) ? text : undefined;

            var result = void 0;
            var items = [].concat(_toConsumableArray(clipboardData.items));
            items.filter(function (item) {
                return item.kind === DATA_TRANSFER_ITEM_KINDS.FILE;
            }).forEach(function (item) {
                var file = item.getAsFile();

                if (!file) {
                    console.warn('Unable to read file');
                    return;
                }

                var validationError = (0, _fileValidator.validateImageFile)(file);

                if (validationError) {
                    var elementId = createShortcutImage({ location: location });
                    dispatchErrorUploadingElementAttachment({
                        id: elementId,
                        error: validationError
                    });
                    result = elementId;
                    return result;
                }

                result = createShortcutImage({ location: location, file: file, caption: caption, showCaption: false });
            });

            return result;
        }, _this.handleLink = function (_ref3) {
            var clipboardData = _ref3.clipboardData,
                location = _ref3.location;

            // If there's no text data transfer type then can't get a link from the pasted data
            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.PLAIN_TEXT)) return;

            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
            if (!(0, _linkUtils.isTextLink)(text)) return;

            var _this$props3 = _this.props,
                createShortcutLink = _this$props3.createShortcutLink,
                deselectAll = _this$props3.deselectAll;

            var linkElementId = createShortcutLink({ location: location, url: text });
            deselectAll();
            return linkElementId;
        }, _this.handleHtml = function (_ref4) {
            var clipboardData = _ref4.clipboardData,
                location = _ref4.location;

            // If there's no html data transfer type then can't get HTML from the pasted data
            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.HTML)) return;

            var createShortcutCard = _this.props.createShortcutCard;

            var html = clipboardData.getData(DATA_TRANSFER_TYPES.HTML);

            if (!html) return;

            return createShortcutCard({ location: location, html: html });
        }, _this.handlePlainText = function (_ref5) {
            var clipboardData = _ref5.clipboardData,
                location = _ref5.location;

            // If there's no text data transfer type then can't get text from the pasted data
            if (!(0, _lodash.includes)(clipboardData.types, DATA_TRANSFER_TYPES.PLAIN_TEXT)) return;

            var createShortcutCard = _this.props.createShortcutCard;

            var text = clipboardData.getData(DATA_TRANSFER_TYPES.PLAIN_TEXT);
            return createShortcutCard({ location: location, text: text });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WorkspaceClipboardHandler, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.addEventListener('paste', this.onPaste);
            document.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('paste', this.onPaste);
            document.removeEventListener('keydown', this.onKeyDown);
        }

        /**
         * Focus the content editable so that Firefox (and I think Safari) can accept the paste events.
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement('div', { ref: function ref(c) {
                    _this2.clipboardDiv = c;
                }, className: 'WorkspaceClipboardHandler',
                contentEditable: true, value: ' ' });
        }
    }]);

    return WorkspaceClipboardHandler;
}(_react2.default.Component);

WorkspaceClipboardHandler.propTypes = {
    isEditable: _propTypes2.default.bool,
    deselectAll: _propTypes2.default.func,
    createShortcutCard: _propTypes2.default.func,
    createShortcutLink: _propTypes2.default.func,
    createShortcutImage: _propTypes2.default.func,
    dispatchErrorUploadingElementAttachment: _propTypes2.default.func,
    currentBoardId: _propTypes2.default.string
};

exports.default = WorkspaceClipboardHandler;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/shortcuts/WorkspaceClipboardHandler.js
// module id = 2215
// module chunks = 0